(async () => {
  if (!customElements.get('sticky-add-to-cart')) {
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();

        this.options = this.querySelectorAll('[data-atc-option]');
        this.productForm = document.querySelector('product-form');

        if (!this.productForm) return;

        this.options?.forEach((option) => {
          option.addEventListener('click', () => {
            this.handleOptionClick(option);
          });
        });

        this.atcButton = this.querySelector('[data-sticky-add-to-cart]');
        this.atcButton.addEventListener('click', this.openModal.bind(this));

        this.overlay = this.querySelector('[data-atc-overlay]');
        this.overlay?.addEventListener('click', this.handleClickOutside.bind(this));

        this.close = this.querySelector('[data-close-button]');
        this.close?.addEventListener('click', this.closeModal.bind(this));

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries, observer) => {
            entries.forEach((section) => {
              !section.isIntersecting
                ? this.atcButton.classList.add('!translate-y-0')
                : this.atcButton.classList.remove('!translate-y-0');
            });
          });

          this.observer.observe(this.productForm.querySelector('[type="submit"]'));
        }
      }

      handleOptionClick(option) {
        const hiddenId = this.productForm.querySelector('input[name="id"]');
        const hiddenInventoryQty = this.productForm.querySelector(
          'input[name="inventory_quantity"]'
        );
        const submitButton = this.productForm.querySelector('[type="submit"]');

        hiddenId.value = option.value;
        hiddenInventoryQty.value = option.dataset.inventoryQuantity;
        submitButton.click();

        this.closeModal();
      }

      handleClickOutside(e) {
        if (!e.target.closest('[data-atc-modal]')) {
          this.closeModal();
        }
      }

      openModal() {
        this.classList.remove('delay-animation');
        this.classList.add('is-open');
        document.body.classList.add('sticky-atc-modal--open');
      }

      closeModal() {
        this.classList.add('delay-animation');
        this.classList.remove('is-open');
        document.body.classList.remove('sticky-atc-modal--open');
      }
    }

    window.StickyAddToCart = StickyAddToCart;

    customElements.define('sticky-add-to-cart', StickyAddToCart);
  }
})();
